module.exports = __webpack_public_path__ + "img/5.a273df63.jpg";